function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 15,
  cy: 15,
  fill: "currentColor",
  fillRule: "nonzero",
  r: 14.5,
  stroke: "#071920"
}), React.createElement("g", {
  transform: "translate(5 5)"
}, React.createElement("g", {
  stroke: "#071920",
  strokeLinecap: "round"
}, React.createElement("path", {
  className: "icon",
  d: "m7.9 9.69v8.85c-.00269112.1210705.04352875.2381157.12821356.3246824s.20068603.1353475.32178644.1353176h3.26c.2849521-.0053276.5146724-.2350479.52-.52v-9.57c.0000479-.31093806-.2491098-.56454495-.56-.57h-4.4c-.21326713.02479283-.40954293-.11914275-.45-.33l-.56-2.44c-.00541177-.03311368-.00541177-.06688632 0-.1 0-.25405098.20594902-.46.46-.46h6.78c.254051 0 .46.20594902.46.46.0054118.03311368.0054118.06688632 0 .1l-.56 2.56",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon",
  d: "m9.87 3.69v-1z",
  strokeLinejoin: "round"
})), React.createElement("path", {
  d: "m0 0h20v20h-20z"
})));

var SvgTower = function SvgTower(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: 30,
    height: 30,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tower.ac0285bd.svg";
export { ForwardRef as ReactComponent };